import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import "@/Admin.css";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try { await login(form.email, form.password); } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); } finally { setBusy(false); }
  };

  return (
    <div className="admin-login" data-testid="admin-login-page">
      <div className="login-panel">
        <div className="brand-mark light"><span className="brand-icon">G</span><span>Golden Beauty <b>Touch</b></span></div>
        <p className="eyebrow light"><Lock size={11} /> PRIVATE STUDIO ACCESS</p>
        <h1>Welcome back,<br /><em>Monika.</em></h1>
        <form onSubmit={submit} className="login-form" data-testid="admin-login-form">
          <label>Email<input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" required autoComplete="username" data-testid="admin-email-input" /></label>
          <label>Password<input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" required autoComplete="current-password" data-testid="admin-password-input" /></label>
          {error && <p className="error-message" data-testid="admin-login-error">{error}</p>}
          <button className="gold-button" type="submit" disabled={busy} data-testid="admin-login-submit">{busy ? "Signing in…" : "Enter dashboard"} <ArrowUpRight size={17} /></button>
        </form>
        <a href="/" className="back-link" data-testid="admin-back-home-link">← Back to website</a>
      </div>
    </div>
  );
}
